import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceLineItem } from 'src/app/core/models/commerce/invoice-line-item.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';


@Component({
  selector: 'app-invoice-line-item-modal',
  templateUrl: './invoice-line-item-modal.component.html',
  styleUrls: ['./invoice-line-item-modal.component.scss']
})
export class InvoiceLineItemModalComponent {

  ContactEdited: boolean = false;
  submitDisabled:boolean  = true; 
  isTaxable:boolean = false; 

  lineItem: InvoiceLineItem = new InvoiceLineItem(); 

  @Input() invoiceList: InvoiceLineItem[] = []; 
  @Output() reloadList = new EventEmitter<any>(); 

  constructor(
    public myFileApiService: MyfileApiService, 
    public authService: AuthMyfileService,
    private modalRef: NgbActiveModal,
   ) 
  {}
  
  createItem(){ 
      this.lineItem.quantity = 1; 
      this.invoiceList.push(this.lineItem);
      this.close(); 
  }
    
  close(){
    this.modalRef.close();
  }

  updateTax(){

    if(this.isTaxable){
      this.lineItem.amount = parseFloat(this.lineItem.amount.toString());
      this.lineItem.tax = this.lineItem.amount * GlobalComponent.taxValue; 
    }else{
      this.lineItem.tax = 0.00
    }
  }


}
